// extracted by mini-css-extract-plugin
module.exports = {"content":"TabContentFriends_content__MX8B_","table":"TabContentFriends_table__32Yae","buttons":"TabContentFriends_buttons__17nvc"};